import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updateContractBillDetailsSchema = z.object({
  contract: z.object({
    cycle: optionSchema,
    cycle_start_day: z
      .object({
        label: z.string(),
        value: z.string(),
      })
      .optional()
      .refine((value) => value?.value !== undefined, {
        message: 'Campo obrigatório',
      }),
    cycle_fixed_interval: z.string().optional(),
    closing_to_due_in_days: optionSchema,
    bill_grouping_mode: optionSchema,
    bill_sub_grouping_mode: optionSchema,
    bill_by: optionSchema,
    payment_method: optionSchema,
    due_to_suspension_in_days: optionSchema,
    cnpj_for_fiscal_document: optionSchema,
  }).superRefine((data, ctx) => {
    if(data.cycle.value === 'fixed') {
      const cycleFixedIntevalValue = Number(data.cycle_fixed_interval)

      if(!data.cycle_fixed_interval || Number.isNaN(cycleFixedIntevalValue)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Campo obrigatório',
          path: ['cycle_fixed_interval']
        })
      } else if(cycleFixedIntevalValue < 5) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Mínimo de 5 dias',
          path: ['cycle_fixed_interval']
        })
      } else if(cycleFixedIntevalValue > 365) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Máximo de 365',
          path: ['cycle_fixed_interval']
        })
      }
    }
  })
})

export type UpdateContractBillDetailsSchema = z.infer<typeof updateContractBillDetailsSchema>
